var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReferenceChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ReferenceIcon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.batchChecked{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "batchChecked",
    d: "M13.76,6.75C13.76,3.58,11.18,1,8.01,1S2.26,3.58,2.26,6.75c0,2.04,1.07,3.83,2.68,4.85v2.03 c0,0.54,0.31,1.02,0.8,1.25c0.5,0.23,1.06,0.14,1.47-0.22l0.96-0.84l0.96,0.84C9.39,14.88,9.7,15,10.03,15 c0.19,0,0.39-0.04,0.57-0.12c0.5-0.23,0.8-0.7,0.8-1.25v-2.25C12.82,10.34,13.76,8.65,13.76,6.75z M3.76,6.75 c0-2.34,1.91-4.25,4.25-4.25s4.25,1.91,4.25,4.25S10.35,11,8.01,11c-0.56,0-1.08-0.11-1.57-0.31v-0.03H6.35 C4.83,10.02,3.76,8.51,3.76,6.75z M6.44,13.35v-1.07c0.35,0.1,0.71,0.17,1.08,0.2c-0.09,0.05-0.18,0.08-0.25,0.15L6.44,13.35z  M9.89,13.35l-0.83-0.72c-0.09-0.08-0.2-0.13-0.3-0.18c0.39-0.05,0.77-0.14,1.13-0.27V13.35z M7.11,8.76 c0.13,0.11,0.3,0.17,0.48,0.17c0.02,0,0.05,0,0.07,0c0.2-0.02,0.38-0.12,0.51-0.27l2.35-2.86c0.26-0.32,0.22-0.79-0.1-1.06 c-0.32-0.26-0.79-0.22-1.06,0.1L7.49,7.13L6.91,6.65C6.6,6.39,6.12,6.43,5.86,6.75s-0.22,0.79,0.1,1.06L7.11,8.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReferenceChecked);
export default __webpack_public_path__ + "static/media/icon_referenceChecked.2c621a7fb3580fdde4f2bd3a7915f508.svg";
export { ForwardRef as ReactComponent };